const MEL = "Australia/Melbourne";

// Convert a datetime-local string (interpreted as Melbourne wall time) to a UTC ISO string.
export function melbourneLocalToISO(localStr) {
  if (!localStr) return null;
  const asUTC = new Date(localStr.length === 16 ? localStr + ":00Z" : localStr + "Z");
  const melWall = new Date(asUTC.toLocaleString("en-US", { timeZone: MEL }));
  const utcWall = new Date(asUTC.toLocaleString("en-US", { timeZone: "UTC" }));
  const offsetMs = melWall.getTime() - utcWall.getTime();
  return new Date(asUTC.getTime() - offsetMs).toISOString();
}

// Convert a UTC ISO string to a datetime-local value (Melbourne wall time).
export function isoToMelbourneLocal(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = d.toLocaleString("sv-SE", { timeZone: MEL });
  return s.replace(" ", "T").slice(0, 16);
}

// Current Melbourne week Monday (YYYY-MM-DD)
export function currentWeekStart() {
  const now = new Date();
  const s = now.toLocaleString("sv-SE", { timeZone: MEL }).slice(0, 10);
  const d = new Date(s + "T00:00:00");
  const day = (d.getDay() + 6) % 7; // Mon=0
  d.setDate(d.getDate() - day);
  return d.toISOString().slice(0, 10);
}

export function addDays(dateStr, n) {
  const d = new Date(dateStr + "T00:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

export function ddmmyyyy(dateStr) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-");
  return `${d}/${m}/${y}`;
}

export function todayMel() {
  return new Date().toLocaleString("sv-SE", { timeZone: MEL }).slice(0, 10);
}

export function fortnightStart(dateStr) {
  const epoch = new Date("2024-01-01T00:00:00");
  const d = new Date(dateStr + "T00:00:00");
  const days = Math.floor((d - epoch) / 86400000);
  const idx = Math.floor(days / 14);
  const s = new Date(epoch.getTime() + idx * 14 * 86400000);
  return s.toISOString().slice(0, 10);
}

export function fmtTime12(hhmm) {
  if (!hhmm) return "";
  let [h, m] = hhmm.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${String(m).padStart(2, "0")} ${ap}`;
}
